import React from 'react';

import { AdvantageIcon, BoxBackground, InitiativeBoxSvg, SignedNumberDice } from '@dndbeyond/character-components/es';
import { CharacterTheme } from '@dndbeyond/character-rules-engine/es';
import { DiceTools, IRollContext, RollType } from '@dndbeyond/dice';
import { GameLogContext } from '@dndbeyond/game-log-components';

interface Props {
    initiative: number;
    hasInitiativeAdvantage: boolean;
    theme: CharacterTheme;
    onClick?: () => void;
    diceEnabled: boolean;
    rollContext: IRollContext;
}
class InitiativeBox extends React.PureComponent<Props> {
    handleClick = (evt: React.MouseEvent): void => {
        const { onClick } = this.props;

        if (onClick) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            onClick();
        }
    };

    render() {
        const { initiative, hasInitiativeAdvantage, theme, diceEnabled, rollContext } = this.props;

        const [{ messageTargetOptions, defaultMessageTargetOption, userId }] = this.context;

        return (
            <div className="ct-initiative-box" onClick={this.handleClick}>
                <div className="ct-initiative-box__value">
                    <BoxBackground StyleComponent={InitiativeBoxSvg} theme={theme} />
                    <SignedNumberDice
                        number={initiative}
                        size={'large'}
                        diceNotation={DiceTools.CustomD20(initiative)}
                        rollType={RollType.Roll}
                        rollAction={'Initiative'}
                        diceEnabled={diceEnabled}
                        advMenu={true}
                        isDarkMode={theme.isDarkMode}
                        themeColor={theme.themeColor}
                        rollContext={rollContext}
                        rollTargetOptions={
                            messageTargetOptions ? Object.values(messageTargetOptions?.entities) : undefined
                        }
                        rollTargetDefault={defaultMessageTargetOption}
                        userId={userId}
                    />
                </div>
                {hasInitiativeAdvantage && (
                    <div className="ct-initiative-box__advantage">
                        <AdvantageIcon
                            theme={theme}
                            className="ct-initiative-box__advantage-icon"
                            title={'Advantage on Initiative'}
                        />
                    </div>
                )}
            </div>
        );
    }
}

InitiativeBox.contextType = GameLogContext;

export default InitiativeBox;
